import axios from "axios";
import { GET_SINGLE_INQUIRY_LIST } from "../../apiConstants";

export const single_Inquiry_Page = (paramObj) => {
    const jwt_token = localStorage.getItem("token");
    return axios.get(`${process.env.REACT_APP_API_URL}${GET_SINGLE_INQUIRY_LIST}`, {
        headers: { Authorization: jwt_token },
        params: paramObj,
    });
};